var map = {
	"./jdf/images/android-clear-history.webp": 725,
	"./jdf/images/btn-service.webp": 726,
	"./jdf/images/btn/btn_activity.webp": 727,
	"./jdf/images/btn/btn_join.webp": 728,
	"./jdf/images/btn/btn_ka.webp": 729,
	"./jdf/images/btn/btn_know.webp": 730,
	"./jdf/images/btn/btn_maintain.webp": 731,
	"./jdf/images/btn/game_gchess.webp": 732,
	"./jdf/images/btn/game_gegame.webp": 733,
	"./jdf/images/btn/game_gfish.webp": 734,
	"./jdf/images/btn/game_glive.webp": 735,
	"./jdf/images/btn/game_glotto.webp": 736,
	"./jdf/images/btn/game_gslot.webp": 737,
	"./jdf/images/btn/game_gsport.webp": 738,
	"./jdf/images/btn/gchess.webp": 739,
	"./jdf/images/btn/gegame.webp": 740,
	"./jdf/images/btn/gfish.webp": 741,
	"./jdf/images/btn/glive.webp": 742,
	"./jdf/images/btn/glotto.webp": 743,
	"./jdf/images/btn/gsport.webp": 744,
	"./jdf/images/btn/mobile_game_gchess.webp": 745,
	"./jdf/images/btn/mobile_game_gegame.webp": 746,
	"./jdf/images/btn/mobile_game_gfish.webp": 747,
	"./jdf/images/btn/mobile_game_glive.webp": 748,
	"./jdf/images/btn/mobile_game_glotto.webp": 749,
	"./jdf/images/btn/mobile_game_gslot.webp": 750,
	"./jdf/images/btn/mobile_game_gsport.webp": 751,
	"./jdf/images/btn/seo/seo_bling.webp": 752,
	"./jdf/images/btn/seo/seo_bling2.webp": 753,
	"./jdf/images/btn/seo/seo_gchess_item01.webp": 754,
	"./jdf/images/btn/seo/seo_gchess_item02.webp": 755,
	"./jdf/images/btn/seo/seo_gchess_item03.webp": 756,
	"./jdf/images/btn/seo/seo_gchess_item04.webp": 757,
	"./jdf/images/btn/seo/seo_gchess_item05.webp": 758,
	"./jdf/images/btn/seo/seo_gchess_item06.webp": 759,
	"./jdf/images/btn/seo/seo_gegame_item01.webp": 760,
	"./jdf/images/btn/seo/seo_gegame_item02.webp": 761,
	"./jdf/images/btn/seo/seo_gegame_item03.webp": 762,
	"./jdf/images/btn/seo/seo_gfish_item01.webp": 763,
	"./jdf/images/btn/seo/seo_gfish_item02.webp": 764,
	"./jdf/images/btn/seo/seo_gfish_item03.webp": 765,
	"./jdf/images/btn/seo/seo_gfish_item04.webp": 766,
	"./jdf/images/btn/seo/seo_glive_item01.webp": 767,
	"./jdf/images/btn/seo/seo_glive_item02.webp": 768,
	"./jdf/images/btn/seo/seo_glive_item03.webp": 769,
	"./jdf/images/btn/seo/seo_glive_item04.webp": 770,
	"./jdf/images/btn/seo/seo_glive_item05.webp": 771,
	"./jdf/images/btn/seo/seo_glotto_item01.webp": 772,
	"./jdf/images/btn/seo/seo_glotto_item02.webp": 773,
	"./jdf/images/btn/seo/seo_glotto_item03.webp": 774,
	"./jdf/images/btn/seo/seo_glotto_item04.webp": 775,
	"./jdf/images/btn/seo/seo_glotto_item05.webp": 776,
	"./jdf/images/btn/seo/seo_glotto_item06.webp": 777,
	"./jdf/images/btn/seo/seo_gsport_item01.webp": 778,
	"./jdf/images/btn/seo/seo_gsport_item02.webp": 779,
	"./jdf/images/btn/seo/seo_gsport_item03.webp": 780,
	"./jdf/images/btn/seo/seo_gsport_item04.webp": 781,
	"./jdf/images/btn/seo/seo_gsport_item05.webp": 782,
	"./jdf/images/festival/duanwu/header_bg.webp": 783,
	"./jdf/images/festival/duanwu/icon_deposit.webp": 784,
	"./jdf/images/festival/duanwu/icon_diamond.webp": 785,
	"./jdf/images/festival/duanwu/icon_home.webp": 786,
	"./jdf/images/festival/duanwu/icon_my.webp": 787,
	"./jdf/images/festival/duanwu/icon_promo.webp": 788,
	"./jdf/images/festival/duanwu/icon_ser.webp": 789,
	"./jdf/images/festival/duanwu/mb_bg.webp": 790,
	"./jdf/images/festival/duanwu/mb_footer_bg.webp": 791,
	"./jdf/images/festival/duanwu/mb_product_bg.webp": 792,
	"./jdf/images/festival/duanwu/mb_product_bg_small.webp": 793,
	"./jdf/images/festival/duanwu/pc_bg.webp": 794,
	"./jdf/images/festival/duanwu/pc_footer_bg.webp": 795,
	"./jdf/images/festival/duanwu/pc_footer_img.webp": 796,
	"./jdf/images/festival/duanwu/pc_header_bg.webp": 797,
	"./jdf/images/festival/duanwu/pc_leaf_L.webp": 798,
	"./jdf/images/festival/duanwu/pc_leaf_R.webp": 799,
	"./jdf/images/festival/duanwu/pc_main_bg.webp": 800,
	"./jdf/images/festival/duanwu/pc_nav_bg.webp": 801,
	"./jdf/images/festival/duanwu/pc_top_bg_2.webp": 802,
	"./jdf/images/festival/moon/game-card-title.webp": 803,
	"./jdf/images/festival/moon/game-card.webp": 804,
	"./jdf/images/festival/moon/header_bg.webp": 805,
	"./jdf/images/festival/moon/icon/icon_deposit.webp": 806,
	"./jdf/images/festival/moon/icon/icon_diamond.webp": 807,
	"./jdf/images/festival/moon/icon/icon_home.webp": 808,
	"./jdf/images/festival/moon/icon/icon_my.webp": 809,
	"./jdf/images/festival/moon/icon/icon_promo.webp": 810,
	"./jdf/images/festival/moon/icon/icon_ser.webp": 811,
	"./jdf/images/festival/moon/icon_deposit.webp": 812,
	"./jdf/images/festival/moon/icon_diamond.webp": 813,
	"./jdf/images/festival/moon/icon_home.webp": 814,
	"./jdf/images/festival/moon/icon_my.webp": 815,
	"./jdf/images/festival/moon/icon_pc_moon.webp": 816,
	"./jdf/images/festival/moon/icon_promo.webp": 817,
	"./jdf/images/festival/moon/icon_ser.webp": 818,
	"./jdf/images/festival/moon/mb_bg.webp": 819,
	"./jdf/images/festival/moon/mb_bg2.webp": 820,
	"./jdf/images/festival/moon/mb_bg_old.webp": 821,
	"./jdf/images/festival/moon/mb_footer_bg.webp": 822,
	"./jdf/images/festival/moon/mb_footer_bg2.webp": 823,
	"./jdf/images/festival/moon/mb_product_bg.webp": 824,
	"./jdf/images/festival/moon/mb_product_bg_small.webp": 825,
	"./jdf/images/festival/moon/micon.webp": 826,
	"./jdf/images/festival/moon/pc/bt-flower-001.webp": 827,
	"./jdf/images/festival/moon/pc/bt-flower-002.webp": 828,
	"./jdf/images/festival/moon/pc/cloud-maple-left.webp": 829,
	"./jdf/images/festival/moon/pc/mapletree.webp": 830,
	"./jdf/images/festival/moon/pc/pc_footer_img.webp": 831,
	"./jdf/images/festival/moon/pc/pc_footer_img2.webp": 832,
	"./jdf/images/festival/moon/pc/rabbit-001.webp": 833,
	"./jdf/images/festival/moon/pc/rabbit-002.webp": 834,
	"./jdf/images/festival/moon/pc/tree.webp": 835,
	"./jdf/images/festival/moon/pc/wave.webp": 836,
	"./jdf/images/festival/moon/pc/wave2.webp": 837,
	"./jdf/images/festival/moon/pc/wave3.webp": 838,
	"./jdf/images/festival/moon/pc_banner_bottom.webp": 839,
	"./jdf/images/festival/moon/pc_bg.webp": 840,
	"./jdf/images/festival/moon/pc_footer_bg.webp": 841,
	"./jdf/images/festival/moon/pc_footer_img.webp": 842,
	"./jdf/images/festival/moon/pc_header_bg.webp": 843,
	"./jdf/images/festival/moon/pc_leaf_L.webp": 844,
	"./jdf/images/festival/moon/pc_leaf_R.webp": 845,
	"./jdf/images/festival/moon/pc_main_bg.webp": 846,
	"./jdf/images/festival/moon/pc_nav_bg.webp": 847,
	"./jdf/images/festival/moon/sidebar-active.webp": 848,
	"./jdf/images/festival/moon/sidebar-default.webp": 849,
	"./jdf/images/festival/newyear/flower_center.webp": 850,
	"./jdf/images/festival/newyear/icon-chess.webp": 851,
	"./jdf/images/festival/newyear/icon-egame.webp": 852,
	"./jdf/images/festival/newyear/icon-fish.webp": 853,
	"./jdf/images/festival/newyear/icon-hot.webp": 854,
	"./jdf/images/festival/newyear/icon-live.webp": 855,
	"./jdf/images/festival/newyear/icon-lottery.webp": 856,
	"./jdf/images/festival/newyear/icon-recommend.webp": 857,
	"./jdf/images/festival/newyear/icon-sport.webp": 858,
	"./jdf/images/festival/newyear/icon_consignment.webp": 859,
	"./jdf/images/festival/newyear/icon_home.webp": 860,
	"./jdf/images/festival/newyear/icon_my.webp": 861,
	"./jdf/images/festival/newyear/icon_pormo.webp": 862,
	"./jdf/images/festival/newyear/icon_ser.webp": 863,
	"./jdf/images/festival/newyear/icon_topUp.webp": 864,
	"./jdf/images/festival/newyear/main_bg.webp": 865,
	"./jdf/images/festival/newyear/main_bg_old.webp": 866,
	"./jdf/images/festival/newyear/mb_header_bg.webp": 867,
	"./jdf/images/festival/newyear/mb_header_bg2.webp": 868,
	"./jdf/images/festival/newyear/navbar-item-active.webp": 869,
	"./jdf/images/festival/newyear/navbar-item-default.webp": 870,
	"./jdf/images/festival/newyear/news_top_img.webp": 871,
	"./jdf/images/festival/newyear/pc_bg.webp": 872,
	"./jdf/images/festival/newyear/pc_bigwin_bg.webp": 873,
	"./jdf/images/festival/newyear/pc_dragon_bg.webp": 874,
	"./jdf/images/festival/newyear/pc_flower_L.webp": 875,
	"./jdf/images/festival/newyear/pc_flower_R.webp": 876,
	"./jdf/images/festival/newyear/pc_footer_img.webp": 877,
	"./jdf/images/festival/newyear/pc_header_bg.webp": 878,
	"./jdf/images/festival/newyear/pc_header_bg_old.webp": 879,
	"./jdf/images/festival/newyear/pc_lion_bg.webp": 880,
	"./jdf/images/festival/newyear/pc_main_bg.webp": 881,
	"./jdf/images/festival/newyear/product_img_bg_big.webp": 882,
	"./jdf/images/festival/newyear/product_img_bg_small.webp": 883,
	"./jdf/images/festival/skin/header_bg.webp": 884,
	"./jdf/images/festival/skin/mb_bg.webp": 885,
	"./jdf/images/festival/skin/mobile/icon_deposit.webp": 886,
	"./jdf/images/festival/skin/mobile/icon_diamond.webp": 887,
	"./jdf/images/festival/skin/mobile/icon_home.webp": 888,
	"./jdf/images/festival/skin/mobile/icon_my.webp": 889,
	"./jdf/images/festival/skin/mobile/icon_promo.webp": 890,
	"./jdf/images/festival/skin/mobile/icon_ser.webp": 891,
	"./jdf/images/festival/skin/pc_banner_bottom.webp": 892,
	"./jdf/images/festival/skin/pc_bg.webp": 893,
	"./jdf/images/festival/skin/pc_footer_img.webp": 894,
	"./jdf/images/festival/skin/pc_header_bg.webp": 895,
	"./jdf/images/festival/skin/pc_main_bg.webp": 896,
	"./jdf/images/festival/xmas/bling-holo.webp": 897,
	"./jdf/images/festival/xmas/icon-snow.webp": 898,
	"./jdf/images/festival/xmas/icon_consignment.webp": 899,
	"./jdf/images/festival/xmas/icon_home.webp": 900,
	"./jdf/images/festival/xmas/icon_menu.webp": 901,
	"./jdf/images/festival/xmas/icon_pc_moon.webp": 902,
	"./jdf/images/festival/xmas/icon_promo.webp": 903,
	"./jdf/images/festival/xmas/icon_service.webp": 904,
	"./jdf/images/festival/xmas/icon_topUp.webp": 905,
	"./jdf/images/festival/xmas/left_menu.webp": 906,
	"./jdf/images/festival/xmas/left_menu_active.webp": 907,
	"./jdf/images/festival/xmas/mb_product_bg.webp": 908,
	"./jdf/images/festival/xmas/mb_product_bg_small.webp": 909,
	"./jdf/images/festival/xmas/nav_bg.webp": 910,
	"./jdf/images/festival/xmas/obj_santaHat.webp": 911,
	"./jdf/images/festival/xmas/obj_snow.webp": 912,
	"./jdf/images/festival/xmas/platform_bg.webp": 913,
	"./jdf/images/festival/xmas/platform_small_bg.webp": 914,
	"./jdf/images/festival/xmas/xmas-bg.webp": 915,
	"./jdf/images/festival/xmas/xmas-head.webp": 916,
	"./jdf/images/festival/xmas/xmas-new_m.webp": 917,
	"./jdf/images/game/desktop/product_1.webp": 918,
	"./jdf/images/game/desktop/product_10.webp": 919,
	"./jdf/images/game/desktop/product_101.webp": 920,
	"./jdf/images/game/desktop/product_102.webp": 921,
	"./jdf/images/game/desktop/product_103.webp": 922,
	"./jdf/images/game/desktop/product_104.webp": 923,
	"./jdf/images/game/desktop/product_106.webp": 924,
	"./jdf/images/game/desktop/product_107.webp": 925,
	"./jdf/images/game/desktop/product_108.webp": 926,
	"./jdf/images/game/desktop/product_109.webp": 927,
	"./jdf/images/game/desktop/product_11.webp": 928,
	"./jdf/images/game/desktop/product_110.webp": 929,
	"./jdf/images/game/desktop/product_112.webp": 930,
	"./jdf/images/game/desktop/product_118.webp": 931,
	"./jdf/images/game/desktop/product_12.webp": 932,
	"./jdf/images/game/desktop/product_121.webp": 933,
	"./jdf/images/game/desktop/product_13.webp": 934,
	"./jdf/images/game/desktop/product_14.webp": 935,
	"./jdf/images/game/desktop/product_15.webp": 936,
	"./jdf/images/game/desktop/product_16.webp": 937,
	"./jdf/images/game/desktop/product_17.webp": 938,
	"./jdf/images/game/desktop/product_18.webp": 939,
	"./jdf/images/game/desktop/product_19.webp": 940,
	"./jdf/images/game/desktop/product_2.webp": 941,
	"./jdf/images/game/desktop/product_20.webp": 942,
	"./jdf/images/game/desktop/product_21.webp": 943,
	"./jdf/images/game/desktop/product_22.webp": 944,
	"./jdf/images/game/desktop/product_23.webp": 945,
	"./jdf/images/game/desktop/product_24.webp": 946,
	"./jdf/images/game/desktop/product_25.webp": 947,
	"./jdf/images/game/desktop/product_26.webp": 948,
	"./jdf/images/game/desktop/product_27.webp": 949,
	"./jdf/images/game/desktop/product_28.webp": 950,
	"./jdf/images/game/desktop/product_29.webp": 951,
	"./jdf/images/game/desktop/product_3.webp": 952,
	"./jdf/images/game/desktop/product_30.webp": 953,
	"./jdf/images/game/desktop/product_36.webp": 954,
	"./jdf/images/game/desktop/product_39.webp": 955,
	"./jdf/images/game/desktop/product_4.webp": 956,
	"./jdf/images/game/desktop/product_40.webp": 957,
	"./jdf/images/game/desktop/product_41.webp": 958,
	"./jdf/images/game/desktop/product_42.webp": 959,
	"./jdf/images/game/desktop/product_44.webp": 960,
	"./jdf/images/game/desktop/product_45.webp": 961,
	"./jdf/images/game/desktop/product_46.webp": 962,
	"./jdf/images/game/desktop/product_47.webp": 963,
	"./jdf/images/game/desktop/product_49.webp": 964,
	"./jdf/images/game/desktop/product_5.webp": 965,
	"./jdf/images/game/desktop/product_50.webp": 966,
	"./jdf/images/game/desktop/product_51.webp": 967,
	"./jdf/images/game/desktop/product_52.webp": 968,
	"./jdf/images/game/desktop/product_53.webp": 969,
	"./jdf/images/game/desktop/product_6.webp": 970,
	"./jdf/images/game/desktop/product_66.webp": 971,
	"./jdf/images/game/desktop/product_7.webp": 972,
	"./jdf/images/game/desktop/product_70.webp": 973,
	"./jdf/images/game/desktop/product_71.webp": 974,
	"./jdf/images/game/desktop/product_72.webp": 975,
	"./jdf/images/game/desktop/product_73.webp": 976,
	"./jdf/images/game/desktop/product_74.webp": 977,
	"./jdf/images/game/desktop/product_75.webp": 978,
	"./jdf/images/game/desktop/product_77.webp": 979,
	"./jdf/images/game/desktop/product_78.webp": 980,
	"./jdf/images/game/desktop/product_79.webp": 981,
	"./jdf/images/game/desktop/product_8.webp": 982,
	"./jdf/images/game/desktop/product_80.webp": 983,
	"./jdf/images/game/desktop/product_81.webp": 984,
	"./jdf/images/game/desktop/product_82.webp": 985,
	"./jdf/images/game/desktop/product_86.webp": 986,
	"./jdf/images/game/desktop/product_87.webp": 987,
	"./jdf/images/game/desktop/product_89.webp": 988,
	"./jdf/images/game/desktop/product_9.webp": 989,
	"./jdf/images/game/desktop/product_90.webp": 990,
	"./jdf/images/game/desktop/product_94.webp": 991,
	"./jdf/images/game/desktop/product_95.webp": 992,
	"./jdf/images/game/desktop/product_97.webp": 993,
	"./jdf/images/game/desktop/product_98.webp": 994,
	"./jdf/images/game/logo/product_42.webp": 995,
	"./jdf/images/game/logo/product_52.webp": 996,
	"./jdf/images/game/mobile/product-bg.webp": 997,
	"./jdf/images/game/mobile/product-uphold.webp": 998,
	"./jdf/images/game/mobile/product_1.webp": 999,
	"./jdf/images/game/mobile/product_10.webp": 1000,
	"./jdf/images/game/mobile/product_101.webp": 1001,
	"./jdf/images/game/mobile/product_102.webp": 1002,
	"./jdf/images/game/mobile/product_103.webp": 1003,
	"./jdf/images/game/mobile/product_104.webp": 1004,
	"./jdf/images/game/mobile/product_105.webp": 1005,
	"./jdf/images/game/mobile/product_106.webp": 1006,
	"./jdf/images/game/mobile/product_107.webp": 1007,
	"./jdf/images/game/mobile/product_108.webp": 1008,
	"./jdf/images/game/mobile/product_109.webp": 1009,
	"./jdf/images/game/mobile/product_11.webp": 1010,
	"./jdf/images/game/mobile/product_110.webp": 1011,
	"./jdf/images/game/mobile/product_111.webp": 1012,
	"./jdf/images/game/mobile/product_112.webp": 1013,
	"./jdf/images/game/mobile/product_113.webp": 1014,
	"./jdf/images/game/mobile/product_114.webp": 1015,
	"./jdf/images/game/mobile/product_115.webp": 1016,
	"./jdf/images/game/mobile/product_116.webp": 1017,
	"./jdf/images/game/mobile/product_117.webp": 1018,
	"./jdf/images/game/mobile/product_118.webp": 1019,
	"./jdf/images/game/mobile/product_119.webp": 1020,
	"./jdf/images/game/mobile/product_12.webp": 1021,
	"./jdf/images/game/mobile/product_120.webp": 1022,
	"./jdf/images/game/mobile/product_121.webp": 1023,
	"./jdf/images/game/mobile/product_122.webp": 1024,
	"./jdf/images/game/mobile/product_123.webp": 1025,
	"./jdf/images/game/mobile/product_13.webp": 1026,
	"./jdf/images/game/mobile/product_14.webp": 1027,
	"./jdf/images/game/mobile/product_15.webp": 1028,
	"./jdf/images/game/mobile/product_16.webp": 1029,
	"./jdf/images/game/mobile/product_17.webp": 1030,
	"./jdf/images/game/mobile/product_18.webp": 1031,
	"./jdf/images/game/mobile/product_19.webp": 1032,
	"./jdf/images/game/mobile/product_2.webp": 1033,
	"./jdf/images/game/mobile/product_20.webp": 1034,
	"./jdf/images/game/mobile/product_21.webp": 1035,
	"./jdf/images/game/mobile/product_22.webp": 1036,
	"./jdf/images/game/mobile/product_23.webp": 1037,
	"./jdf/images/game/mobile/product_24.webp": 1038,
	"./jdf/images/game/mobile/product_25.webp": 1039,
	"./jdf/images/game/mobile/product_26.webp": 1040,
	"./jdf/images/game/mobile/product_27.webp": 1041,
	"./jdf/images/game/mobile/product_28.webp": 1042,
	"./jdf/images/game/mobile/product_29.webp": 1043,
	"./jdf/images/game/mobile/product_3.webp": 1044,
	"./jdf/images/game/mobile/product_30.webp": 1045,
	"./jdf/images/game/mobile/product_31.webp": 1046,
	"./jdf/images/game/mobile/product_32.webp": 1047,
	"./jdf/images/game/mobile/product_33.webp": 1048,
	"./jdf/images/game/mobile/product_34.webp": 1049,
	"./jdf/images/game/mobile/product_35.webp": 1050,
	"./jdf/images/game/mobile/product_36.webp": 1051,
	"./jdf/images/game/mobile/product_37.webp": 1052,
	"./jdf/images/game/mobile/product_38.webp": 1053,
	"./jdf/images/game/mobile/product_39.webp": 1054,
	"./jdf/images/game/mobile/product_4.webp": 1055,
	"./jdf/images/game/mobile/product_40.webp": 1056,
	"./jdf/images/game/mobile/product_41.webp": 1057,
	"./jdf/images/game/mobile/product_42.webp": 1058,
	"./jdf/images/game/mobile/product_43.webp": 1059,
	"./jdf/images/game/mobile/product_44.webp": 1060,
	"./jdf/images/game/mobile/product_45.webp": 1061,
	"./jdf/images/game/mobile/product_46.webp": 1062,
	"./jdf/images/game/mobile/product_47.webp": 1063,
	"./jdf/images/game/mobile/product_48.webp": 1064,
	"./jdf/images/game/mobile/product_49.webp": 1065,
	"./jdf/images/game/mobile/product_5.webp": 1066,
	"./jdf/images/game/mobile/product_50.webp": 1067,
	"./jdf/images/game/mobile/product_51.webp": 1068,
	"./jdf/images/game/mobile/product_52.webp": 1069,
	"./jdf/images/game/mobile/product_53.webp": 1070,
	"./jdf/images/game/mobile/product_54.webp": 1071,
	"./jdf/images/game/mobile/product_55.webp": 1072,
	"./jdf/images/game/mobile/product_56.webp": 1073,
	"./jdf/images/game/mobile/product_57.webp": 1074,
	"./jdf/images/game/mobile/product_58.webp": 1075,
	"./jdf/images/game/mobile/product_59.webp": 1076,
	"./jdf/images/game/mobile/product_6.webp": 1077,
	"./jdf/images/game/mobile/product_60.webp": 1078,
	"./jdf/images/game/mobile/product_61.webp": 1079,
	"./jdf/images/game/mobile/product_62.webp": 1080,
	"./jdf/images/game/mobile/product_63.webp": 1081,
	"./jdf/images/game/mobile/product_64.webp": 1082,
	"./jdf/images/game/mobile/product_65.webp": 1083,
	"./jdf/images/game/mobile/product_66.webp": 1084,
	"./jdf/images/game/mobile/product_67.webp": 1085,
	"./jdf/images/game/mobile/product_68.webp": 1086,
	"./jdf/images/game/mobile/product_69.webp": 1087,
	"./jdf/images/game/mobile/product_7.webp": 1088,
	"./jdf/images/game/mobile/product_70.webp": 1089,
	"./jdf/images/game/mobile/product_71.webp": 1090,
	"./jdf/images/game/mobile/product_72.webp": 1091,
	"./jdf/images/game/mobile/product_73.webp": 1092,
	"./jdf/images/game/mobile/product_74.webp": 1093,
	"./jdf/images/game/mobile/product_75.webp": 1094,
	"./jdf/images/game/mobile/product_76.webp": 1095,
	"./jdf/images/game/mobile/product_77.webp": 1096,
	"./jdf/images/game/mobile/product_78.webp": 1097,
	"./jdf/images/game/mobile/product_79.webp": 1098,
	"./jdf/images/game/mobile/product_8.webp": 1099,
	"./jdf/images/game/mobile/product_80.webp": 1100,
	"./jdf/images/game/mobile/product_81.webp": 1101,
	"./jdf/images/game/mobile/product_82.webp": 1102,
	"./jdf/images/game/mobile/product_83.webp": 1103,
	"./jdf/images/game/mobile/product_84.webp": 1104,
	"./jdf/images/game/mobile/product_85.webp": 1105,
	"./jdf/images/game/mobile/product_86.webp": 1106,
	"./jdf/images/game/mobile/product_87.webp": 1107,
	"./jdf/images/game/mobile/product_89.webp": 1108,
	"./jdf/images/game/mobile/product_9.webp": 1109,
	"./jdf/images/game/mobile/product_90.webp": 1110,
	"./jdf/images/game/mobile/product_91.webp": 1111,
	"./jdf/images/game/mobile/product_92.webp": 1112,
	"./jdf/images/game/mobile/product_93.webp": 1113,
	"./jdf/images/game/mobile/product_94.webp": 1114,
	"./jdf/images/game/mobile/product_95.webp": 1115,
	"./jdf/images/game/mobile/product_96.webp": 1116,
	"./jdf/images/game/mobile/product_97.webp": 1117,
	"./jdf/images/game/mobile/product_98.webp": 1118,
	"./jdf/images/game/mobile/product_fish.webp": 1119,
	"./jdf/images/game/mobile/product_img_bg.webp": 1120,
	"./jdf/images/game/mobile/product_jackpot.webp": 1121,
	"./jdf/images/game/mobile/product_just8899.webp": 1122,
	"./jdf/images/game/mobile/tool-539.webp": 1123,
	"./jdf/images/game/mobile/tool-check.webp": 1124,
	"./jdf/images/game/mobile/tool-know.webp": 1125,
	"./jdf/images/game/mobile/tool-qa.webp": 1126,
	"./jdf/images/game/mobile/tool-time.webp": 1127,
	"./jdf/images/game/mobile/tool-youtube.webp": 1128,
	"./jdf/images/hot/tool-539.webp": 1129,
	"./jdf/images/hot/tool-appset.webp": 1130,
	"./jdf/images/hot/tool-check.webp": 1131,
	"./jdf/images/hot/tool-just8899.webp": 1132,
	"./jdf/images/hot/tool-know.webp": 1133,
	"./jdf/images/hot/tool-qa.webp": 1134,
	"./jdf/images/hot/tool-time.webp": 1135,
	"./jdf/images/hot/tool-youtube.webp": 1136,
	"./jdf/images/ios-clear-history.webp": 1137,
	"./jdf/images/jackpot/coin1.webp": 1138,
	"./jdf/images/jackpot/coin2.webp": 1139,
	"./jdf/images/jackpot/coin3.webp": 1140,
	"./jdf/images/jackpot/coin4.webp": 1141,
	"./jdf/images/jackpot/coin5.webp": 1142,
	"./jdf/images/jackpot/coin6.webp": 1143,
	"./jdf/images/jackpot/coin7.webp": 1144,
	"./jdf/images/jackpot/jackpot-bg.webp": 1145,
	"./jdf/images/jackpot/jackpot-moonbg.webp": 1146,
	"./jdf/images/jackpot/moon-haedbg.webp": 1147,
	"./jdf/images/luckyWheel/banner-mb.webp": 1148,
	"./jdf/images/luckyWheel/banner.webp": 1149,
	"./jdf/images/luckyWheel/gift.webp": 356,
	"./jdf/images/mobile/app-mb-icon.webp": 1150,
	"./jdf/images/mobile/flex_discount.webp": 1151,
	"./jdf/images/mobile/icon-chess-active.webp": 1152,
	"./jdf/images/mobile/icon-chess.webp": 1153,
	"./jdf/images/mobile/icon-egame-active.webp": 1154,
	"./jdf/images/mobile/icon-egame.webp": 1155,
	"./jdf/images/mobile/icon-fish-active.webp": 1156,
	"./jdf/images/mobile/icon-fish.webp": 1157,
	"./jdf/images/mobile/icon-hot-active.webp": 1158,
	"./jdf/images/mobile/icon-hot.webp": 1159,
	"./jdf/images/mobile/icon-live-active.webp": 1160,
	"./jdf/images/mobile/icon-live.webp": 1161,
	"./jdf/images/mobile/icon-lottery-active.webp": 1162,
	"./jdf/images/mobile/icon-lottery.webp": 1163,
	"./jdf/images/mobile/icon-recommend-active.webp": 1164,
	"./jdf/images/mobile/icon-recommend.webp": 1165,
	"./jdf/images/mobile/icon-sport-active.webp": 1166,
	"./jdf/images/mobile/icon-sport.webp": 1167,
	"./jdf/images/mobile/icon_active_bg.webp": 1168,
	"./jdf/images/pc/app-img.webp": 396,
	"./jdf/images/pc/cover.webp": 394,
	"./jdf/images/pc/icon-app-apple.webp": 393,
	"./jdf/images/pc/icon-app-google.webp": 398,
	"./jdf/images/pc/idx-title-download.webp": 391,
	"./jdf/images/pc/product_101.webp": 1169,
	"./jdf/images/sample/sample-1.webp": 357,
	"./jdf/images/sample/sample-2.webp": 1170,
	"./jdf/images/sample/sample-3.webp": 1171,
	"./jdf/images/sample/sample-4.webp": 1172,
	"./jdf/images/sample/sample-error-1.webp": 1173,
	"./jdf/images/sample/sample-error-2.webp": 1174,
	"./jdf/images/sample/sample-error-3.webp": 1175,
	"./jdf/images/sample/sample-error-4.webp": 1176,
	"./jdf/images/sample/sample-error-5.webp": 1177,
	"./jdf/images/signinSheet/banner.webp": 1178,
	"./jdf/images/signinSheet/banner_mb.webp": 1179,
	"./jdf/images/signinSheet/gift.webp": 1180,
	"./jdf/static/images/game/hot/product_1.webp": 1181,
	"./jdf/static/images/game/hot/product_101.webp": 1182,
	"./jdf/static/images/game/hot/product_102.webp": 1183,
	"./jdf/static/images/game/hot/product_103.webp": 1184,
	"./jdf/static/images/game/hot/product_104.webp": 1185,
	"./jdf/static/images/game/hot/product_106.webp": 1186,
	"./jdf/static/images/game/hot/product_107.webp": 1187,
	"./jdf/static/images/game/hot/product_11.webp": 1188,
	"./jdf/static/images/game/hot/product_110.webp": 1189,
	"./jdf/static/images/game/hot/product_112.webp": 1190,
	"./jdf/static/images/game/hot/product_118.webp": 1191,
	"./jdf/static/images/game/hot/product_121.webp": 1192,
	"./jdf/static/images/game/hot/product_13.webp": 1193,
	"./jdf/static/images/game/hot/product_2.webp": 1194,
	"./jdf/static/images/game/hot/product_27.webp": 1195,
	"./jdf/static/images/game/hot/product_29.webp": 1196,
	"./jdf/static/images/game/hot/product_3.webp": 1197,
	"./jdf/static/images/game/hot/product_39.webp": 1198,
	"./jdf/static/images/game/hot/product_4.webp": 1199,
	"./jdf/static/images/game/hot/product_40.webp": 1200,
	"./jdf/static/images/game/hot/product_41.webp": 1201,
	"./jdf/static/images/game/hot/product_44.webp": 1202,
	"./jdf/static/images/game/hot/product_47.webp": 1203,
	"./jdf/static/images/game/hot/product_52.webp": 1204,
	"./jdf/static/images/game/hot/product_53.webp": 1205,
	"./jdf/static/images/game/hot/product_6.webp": 1206,
	"./jdf/static/images/game/hot/product_66.webp": 1207,
	"./jdf/static/images/game/hot/product_7.webp": 1208,
	"./jdf/static/images/game/hot/product_70.webp": 1209,
	"./jdf/static/images/game/hot/product_71.webp": 1210,
	"./jdf/static/images/game/hot/product_72.webp": 1211,
	"./jdf/static/images/game/hot/product_78.webp": 1212,
	"./jdf/static/images/game/hot/product_80.webp": 1213,
	"./jdf/static/images/game/hot/product_81.webp": 1214,
	"./jdf/static/images/game/hot/product_82.webp": 1215,
	"./jdf/static/images/game/hot/product_86.webp": 1216,
	"./jdf/static/images/game/hot/product_87.webp": 1217,
	"./jdf/static/images/game/hot/product_89.webp": 1218,
	"./jdf/static/images/game/hot/product_90.webp": 1219,
	"./jdf/static/images/game/hot/product_94.webp": 1220,
	"./jdf/static/images/game/hot/product_95.webp": 1221,
	"./jdf/static/images/game/hot/product_98.webp": 1222,
	"./jdf/static/images/game/product_1.webp": 1223,
	"./jdf/static/images/game/product_10.webp": 1224,
	"./jdf/static/images/game/product_103.webp": 1225,
	"./jdf/static/images/game/product_11.webp": 1226,
	"./jdf/static/images/game/product_13.webp": 1227,
	"./jdf/static/images/game/product_2.webp": 1228,
	"./jdf/static/images/game/product_21.webp": 1229,
	"./jdf/static/images/game/product_24.webp": 1230,
	"./jdf/static/images/game/product_25.webp": 1231,
	"./jdf/static/images/game/product_26.webp": 1232,
	"./jdf/static/images/game/product_27.webp": 1233,
	"./jdf/static/images/game/product_29.webp": 1234,
	"./jdf/static/images/game/product_3.webp": 1235,
	"./jdf/static/images/game/product_39.webp": 1236,
	"./jdf/static/images/game/product_4.webp": 1237,
	"./jdf/static/images/game/product_40.webp": 1238,
	"./jdf/static/images/game/product_41.webp": 1239,
	"./jdf/static/images/game/product_42.webp": 1240,
	"./jdf/static/images/game/product_44.webp": 1241,
	"./jdf/static/images/game/product_45.webp": 1242,
	"./jdf/static/images/game/product_46.webp": 1243,
	"./jdf/static/images/game/product_47.webp": 1244,
	"./jdf/static/images/game/product_5.webp": 1245,
	"./jdf/static/images/game/product_50.webp": 1246,
	"./jdf/static/images/game/product_51.webp": 1247,
	"./jdf/static/images/game/product_52.webp": 1248,
	"./jdf/static/images/game/product_53.webp": 1249,
	"./jdf/static/images/game/product_6.webp": 1250,
	"./jdf/static/images/game/product_66.webp": 1251,
	"./jdf/static/images/game/product_7.webp": 1252,
	"./jdf/static/images/game/product_70.webp": 1253,
	"./jdf/static/images/game/product_71.webp": 1254,
	"./jdf/static/images/game/product_72.webp": 1255,
	"./jdf/static/images/game/product_73.webp": 1256,
	"./jdf/static/images/game/product_74.webp": 1257,
	"./jdf/static/images/game/product_77.webp": 1258,
	"./jdf/static/images/game/product_78.webp": 1259,
	"./jdf/static/images/game/product_8.webp": 1260,
	"./jdf/static/images/game/product_80.webp": 1261,
	"./jdf/static/images/game/product_81.webp": 1262,
	"./jdf/static/images/game/product_82.webp": 1263,
	"./jdf/static/images/game/product_89.webp": 1264,
	"./jdf/static/images/game/product_9.webp": 1265,
	"./jdf/static/images/game/product_fish.webp": 1266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 345;